import { render, staticRenderFns } from "./QNotificationMenuPoliciesAlert.vue?vue&type=template&id=16a6de4a&scoped=true&"
import script from "./QNotificationMenuPoliciesAlert.vue?vue&type=script&lang=js&"
export * from "./QNotificationMenuPoliciesAlert.vue?vue&type=script&lang=js&"
import style0 from "./QNotificationMenuPoliciesAlert.vue?vue&type=style&index=0&id=16a6de4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a6de4a",
  null
  
)

export default component.exports